import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/brand.css";
import { useEffect, useState ,Link} from "react";
import Modal from 'react-bootstrap/Modal';
import { commonAPI } from "../services/CommonAPIService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMotorcycle, faCar, faEdit, faL, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare, faPaperclip, faPen, faEye, faDeleteLeft, faKey, faEyeSlash, faUserAltSlash } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import { LiaUserCogSolid } from "react-icons/lia";
import { ToastContainer, toast } from "react-toastify";
import FlatIcon from '../assets/img/config-flat.png';
import NoCompany from '../assets/img/ss-notile.png';
import ServiceIcon from '../assets/img/ss-tile.png';
import { useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import {ErrorSource} from '../common/constants'
import onlydots from '../assets/img/3dots.png';
const ServiceStaff = () => {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show9, setShow9] = useState(false);
  const navigate = useNavigate();
  const [logo, setImageLogo] = useState()
  const [Oldlogo, setOldImageLogo] = useState()
  const [loading, setLoading] = useState(false)
  const [fileURL, setFileURL] = useState('');
  const [base64, setBase64] = useState('');
  const [deleteItem, setDeleteItem] = useState("")
  const [imgSizeLarge, setImgSizeLarge] = useState(false)
  const [DeleteShow, setDeleteShow] = useState(false);
  const [ModalText, setModalText] = useState(true);
  const [updatedEdit, setUpdatedEdit] = useState(false)
  const [OTP, setOTP] = useState("")
  const [BuildingList, setBuildingList] = useState("")
  const [StaffName, setStaffName] = useState("")
  const [StaffId, setStaffId] = useState("")
  const [MobileNumber, setMobileNumber] = useState("")
  const [EmailId, setEmailId] = useState("")
  const [Gender, setGender] = useState("")
  const [Dob, setDob] = useState("")
  const [Doj, setDoj] = useState("")
  const [FatherName, setFatherName] = useState("")
  const [JobType, setJobType] = useState("")
  const [DepartmentList, setDepartmentList] = useState("")
  const [DepartmentId, setDepartmentId] = useState("")
  const [RoleList, setRoleList] = useState("")
  const [RoleListSelect, setRoleListSelect] = useState("")
  const [RoleId, setRoleId] = useState("");
  const [Address, setAddress] = useState("")
  const [FileExt, setFileExt] = useState("")
  const [ImageUrlShow, setImageUrlShow] = useState("")
  const [SearchUser, setSearchUser] = useState("");
  const [JobTypeSelectId, setJobTypeSelectId] = useState("");
  const [DepartmentIdSelected, setDepartmentIdSelected] = useState("");
  const [RoleIdSelect, setRoleIdSelect] = useState("")
  const [ShowPassword, setShowPassword] = useState(true)
  const [AccessShow, setAccessShow] = useState(false)
  const [RevokeAccessShow, setRevokeAccessShow] = useState(false)
  const [OTPgentime, setOTPgentime] = useState();
  const [OTPMatch, setOTPMatch] = useState(true);
  const [OTPShow, setOTPShow] = useState(true);
  const [ShowHide, setShowHide] = useState(false);
  const [MobileShowHide, setMobileShowHide] = useState(false);
  const [PassCodeCheck, setPassCodeCheck] = useState(false);
  const [AppAccessEnabled, setAppAccessEnabled] = useState(false);
  console.log("Dob",Dob)

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log("imagefile", file)
    const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!/\.(jpeg|jpg|png)$/i.test(file?.name)) {
      toast.error("Please select an image in JPEG, JPG, or PNG format.");
    } else if (file?.size >= 50000) {
        toast.error("Please select a logo with a size below 50KB.");
    } else {
        const reader = new FileReader();

        reader.onload = () => {
            // atob(item?.logo)
            // console.log("base64======", reader.result)
            const SplitBase64 = reader.result.split("base64,");
            // console.log("SplitBase64======", SplitBase64[1])
            const encodedString = btoa(reader.result);
            setFileURL(reader.result);
            setBase64(reader.result)
            const mimeType = file?.type;
            const parts = mimeType.split("/");
            const extension = parts[1];
            const formattedExtension = `.${extension}`;
            setFileExt(formattedExtension)
          
        };
        reader.readAsDataURL(file);
    }
  }

  


  const openCreateModal = () => {
    setMobileShowHide(false)
    setOTP("")
    setOTPgentime("")
    setFileURL("")
    setBase64("")
    setFileExt("")
    setStaffName("")
    setMobileNumber("")
    setEmailId("")
    setGender("")
    setJobType("")
    setDob("")
    setDoj("")
    setDepartmentId("")
    setRoleId("")
    setFatherName("")
    setAddress("")
    setShow(true)
    setShowHide(false)
    setOTPMatch(true)
    setOTPShow(true)
    setModalText(true);
    setUpdatedEdit(false)
  };

    const GetDepartmentList = async () => {
        const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
        try {
            // let myBuildingId;
            
            setLoading(true);
            const endPointVariableKey = {
                // urlVariable: CategoryIdSelected,
                buildingId:myUserData?.buildingId
            }

            let response = await commonAPI("Department", undefined, endPointVariableKey);
            if (response?.success===true){
                // console.log("Table Department", response)
                // setDepartmentList(response?.data);
                // setLoading(false);

                const filteredDepartments = response?.data?.filter(
                  (item) => item.appAccessEnabled === true
                );

                setDepartmentList(filteredDepartments);
                setLoading(false);

            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "Department",
                "errorNumber": "DL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ServiceStaff.js",
                "functionName": "GetDepartmentList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetRoleList = async () => {
        const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
        try {
            
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: DepartmentId,
                buildingId:myUserData?.buildingId
            }

            let response = await commonAPI("SocietyRole", undefined, endPointVariableKey);
            if (response?.success===true){
                console.log("Table RoleList", response)
                setRoleList(response?.data[0].roles);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "SocietyRole",
                "errorNumber": "SRL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ServiceStaff.js",
                "functionName": "GetSocietyRoleList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetRoleListSelect = async () => {
      const auth = localStorage.getItem("userData");
          const myUserData = JSON.parse(auth);
      try {
          
          setLoading(true);
          const endPointVariableKey = {
              urlVariable: DepartmentIdSelected,
              buildingId:myUserData?.buildingId
          }

          let response = await commonAPI("SocietyRole", undefined, endPointVariableKey);
          if (response?.success===true){
              console.log("Table RoleList", response)
              setRoleListSelect(response?.data[0].roles);
              setLoading(false);
          }else{
              toast.error("Something went wrong");
              setLoading(false);
          }

      } catch (error) {
          console.log(error);
          setLoading(false);
          const bodyError = JSON.stringify({ 
              "userId": myUserData?.userId,
              "mobileNumber": myUserData?.mobileNumber,
              "requestJSON": null,
              "uri": "SocietyRole",
              "errorNumber": "SL01",
              "errorSource": ErrorSource,
              "errorSummary": error?.message,
              "errorDescription": error?.message,
              "fileClassName": "tower.js",
              "functionName": "GetSocietyRoleList2",
          });
          let response = await commonAPI("ErrorLogMaster", bodyError);
          console.log("statusCode", response);
          if (response?.success == true && response?.message?.length == 0) {
              toast.error("Something went wrong");
              setLoading(false);
          } else {
              setLoading(false);
              toast.error("Something went wrong");
          }
      }

  }

    useEffect(() => {
        GetDepartmentList();
    }, []);

    useEffect(() => {
        if(DepartmentId){
            GetRoleList();
        }else{
            setRoleList([])
        }
    }, [DepartmentId]);

    useEffect(() => {
      if(DepartmentIdSelected){
        GetRoleListSelect();
      }else{
          setRoleListSelect([])
      }
  }, [DepartmentIdSelected]);

    function filterServiceStaffData(text) {
        setSearchUser(text);
    
        const newData = Oldlogo?.filter(item => {
            return (
                item?.userName?.toLowerCase().includes(text?.toLowerCase())
            );
        });
    
        setImageLogo(newData);
    }

  const fetchData = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    
    const bodyReq = {
        "userName": null,
        "jobType": JobTypeSelectId ? JobTypeSelectId : null,
        "departmentId": DepartmentIdSelected ? DepartmentIdSelected : null,
        "roleId": RoleIdSelect ? RoleIdSelect : null
    }
    console.log("bodyReq", bodyReq)
    // setLoading(true);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId,
    }
    setLoading(true)
    try {
      let response = await commonAPI("ServiceStaff", bodyReq, endPointVariableKey);
      if (response?.success == true) {
        console.log("ServiceStaff", response);
        setImageLogo(response?.data)
        setOldImageLogo(response?.data)
        setLoading(false)
      }
      else {
        toast.error("Something went wrong")
        setLoading(false)
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = JSON.stringify({ 
          "userId": myUserData?.userId,
          "mobileNumber": myUserData?.mobileNumber,
          "requestJSON": bodyReq,
          "uri": "ServiceStaff",
          "errorNumber": "SSL01",
          "errorSource": ErrorSource,
          "errorSummary": error?.message,
          "errorDescription": error?.message,
          "fileClassName": "ServiceStaff.js",
          "functionName": "GetServiceStaff",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
          toast.error("Something went wrong");
          setLoading(false);
      } else {
          setLoading(false);
          toast.error("Something went wrong");
      }
    }
  };


  useEffect(() => {
    
        fetchData();
      
  }, [JobTypeSelectId, DepartmentIdSelected, RoleIdSelect]);

  const AppAccess = async (item) => {
    console.log("item",item)
    setStaffId(item?.staffId)
    setAccessShow(true)
  }

  const addAppAccess = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodydata = {
      "modifiedUserId": JSON.stringify(myUserData?.userId),
      "staffId": StaffId
    }
    console.log("bodydataSServiceStaffAppAccess", bodydata)
    try {
        setLoading(true);
        const endPointVariableKey = {
            buildingId:myUserData?.buildingId
        }
        let response = await commonAPI("ServiceStaffAppAccess", bodydata, endPointVariableKey);
        if(response?.success == true && response?.message?.length == 0){
            toast.success("App Access Granted"); 
            fetchData();
            setAccessShow(false)
            setLoading(false);
        }else{
            toast.error(response?.message[0]);
            setLoading(false);
        }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = JSON.stringify({ 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodydata,
            "uri": "ServiceStaffAdd",
            "errorNumber": "ASS01",
            "errorSource": ErrorSource,
            "errorSummary": error?.message,
            "errorDescription": error?.message,
            "fileClassName": "ServiceStaff.js",
            "functionName": "addServiceStaff",
        });
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }
  };

  const revokeAppAccess = async (item) => {
    console.log("item", item);
    setStaffId(item?.staffId);
    setRevokeAccessShow(true);
  };

  const removeAppAccess = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodydata = {
      "modifiedUserId": JSON.stringify(myUserData?.userId),
      "staffId": StaffId
    };
    console.log("bodydataServiceStaffRevokeAppAccess", bodydata);
    try {
      setLoading(true);
      const endPointVariableKey = {
        buildingId: myUserData?.buildingId
      };
      let response = await commonAPI("ServiceStaffRevokeAppAccess", bodydata, endPointVariableKey);
      if (response?.success == true && response?.message?.length == 0) {
        toast.success("App Access Revoked");
        fetchData();
        setRevokeAccessShow(false);
        setLoading(false);
      } else {
        toast.error(response?.message[0]);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = JSON.stringify({
        "userId": myUserData?.userId,
        "mobileNumber": myUserData?.mobileNumber,
        "requestJSON": bodydata,
        "uri": "ServiceStaffRevokeAppAccess",
        "errorNumber": "ASS02",
        "errorSource": ErrorSource,
        "errorSummary": error?.message,
        "errorDescription": error?.message,
        "fileClassName": "ServiceStaff.js",
        "functionName": "removeAppAccess",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      setLoading(false);
      toast.error("Something went wrong");
    }
  };

  const addServiceStaff = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodydata = {
        "createdUserId": JSON.stringify(myUserData?.userId),
        "userName": StaffName,
        "mobileNumber": MobileNumber,
        "emailId": EmailId ? EmailId : null,
        "gender": Gender,
        "dob": Dob ? Dob : null,
        "doj": Doj ? Doj : null,
        "jobType": JobType ? JobType : null,
        "fatherName": FatherName ? FatherName : null,
        "roleId": parseInt(RoleId),
        "currentAddress": Address ? Address : null,
        "userImagebase64String": base64 ? base64 : null,
        "fileExtn": FileExt ? FileExt : null,
        "isMobileAuthenticated": true,
        "departmentId": parseInt(DepartmentId)
    }
    console.log("bodydataServiceStaff", bodydata)
    try {
        setLoading(true);
        
        if(!StaffName){
            toast.warning("Please enter Staff Name");
            setLoading(false);
        }else if(!MobileNumber){
            toast.warning("Please enter Mobile Number");
            setLoading(false);
        }else if(!Gender){
            toast.warning("Please select Gender");
            setLoading(false);  
        }else if(!DepartmentId){
            toast.warning("Please select Department");
            setLoading(false);     
        }else if(!RoleId){
            toast.warning("Please select Role");
            setLoading(false);  
        }else{
            const endPointVariableKey = {
                buildingId:myUserData?.buildingId
            }
            let response = await commonAPI("ServiceStaffAdd", bodydata, endPointVariableKey);
            if(response?.success == true && response?.message?.length == 0){
                toast.success("Service Staff Added"); 
                // console.log(response.success);
                fetchData();
                setShow(false)
                setLoading(false);
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
            }
        }    

    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = JSON.stringify({ 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodydata,
            "uri": "ServiceStaffAdd",
            "errorNumber": "ASS01",
            "errorSource": ErrorSource,
            "errorSummary": error?.message,
            "errorDescription": error?.message,
            "fileClassName": "ServiceStaff.js",
            "functionName": "addServiceStaff",
        });
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }
  };

  function DeleteStaff(item) {
    setStaffId(item?.staffId)
    setDeleteShow(true)
  }

  async function DeleteServiceStaff() {
    console.log(deleteItem, "DeleteItem")
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: myUserData?.buildingId
    }
    console.log(myUserData)
    const bodyReq = {
      "modifiedUserId": myUserData?.userId.toString(),
      "staffId": StaffId,
    }
    console.log(bodyReq)
    try {
      const response = await commonAPI("ServiceStaffDelete", bodyReq, endPointVariableKey)
      console.log(response, "RESPONSe")
      if (response?.success == true) {
        setLoading(false)
        setDeleteShow(false)
        fetchData();
        toast.success("Service Staff Deleted")
        // navigate('/Configuration');
      }
      else {
        toast.error(response?.message[0])
        setLoading(false)
      }

    }
    catch (error) {
      setLoading(false);
        const bodyError = JSON.stringify({ 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodyReq,
            "uri": "ServiceStaffDelete",
            "errorNumber": "DSS01",
            "errorSource": ErrorSource,
            "errorSummary": error?.message,
            "errorDescription": error?.message,
            "fileClassName": "ServiceStaff.js",
            "functionName": "DeleteServiceStaff",
        });
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }
  }

  function updateCompanyLogo(item) {
    setUpdatedEdit(true)
    setShowHide(true)
    setMobileShowHide(true)
    setPassCodeCheck(item?.passCode ? true : false)
    const selectedDepartment = DepartmentList.find(dept => dept.departmentId === item?.departmentId);  
    setAppAccessEnabled(selectedDepartment?.appAccessEnabled || false);
    console.log("item",item)
    setFileURL(item?.userImageURL)
    setFileExt("")
    setStaffId(item?.staffId)
    setStaffName(item?.userName)
    setMobileNumber(item?.mobileNumber)
    setEmailId(item?.emailId)
    setGender(item?.gender)
    setJobType(item?.jobType)
    if(item?.dob){
        setDob(convertISTTime(item?.dob))
        console.log("item date", convertISTTime(item?.dob))
    }else{
        setDob(null)
     }   
     if(item?.doj){
        setDoj(convertISTTime(item?.doj))
        console.log("item date", convertISTTime(item?.doj))
    }else{
        setDoj(null)
     }   
    setDepartmentId(item?.departmentId)
    setRoleId(item?.roleId)
    setFatherName(item?.fatherName)
    setAddress(item?.currentAddress)
    setShow(true)
    setModalText(false);
  }

  const convertISTTime = (date) => {
    if (date != null || date != "" || date != undefined) {
      const [datePart, TimePart] = date.split("T");
      const [yyyy, mm, dd] = datePart.split("-");
      const [hh, mn, ss] = TimePart.split(':')
      const formatedTime = `${yyyy}-${mm}-${dd}`;
      return formatedTime;
    } else {
      console.warn("input date string may be null, empty string or undefined");
    }
  };


  async function performUpdate() {

    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodydata = {
        "modifiedUserId": JSON.stringify(myUserData?.userId),
        "userName": StaffName,
        "mobileNumber": MobileNumber,
        "emailId": EmailId ? EmailId : null,
        "gender": Gender,
        "dob": Dob ? Dob : null,
        "doj": Doj ? Doj : null,
        "jobType": JobType ? JobType : null,
        "fatherName": FatherName ? FatherName : null,
        "roleId": parseInt(RoleId),
        "staffId": parseInt(StaffId),
        "currentAddress": Address ? Address : null,
        "userImagebase64String": base64 ? base64 : null,
        "fileExtn": FileExt ? FileExt : null,
        "departmentId": parseInt(DepartmentId)
    }
    console.log("bodydataServiceStaffUpdate", bodydata)
    try {
        setLoading(true);
        
        if(!StaffName){
            toast.warning("Please enter Staff Name");
            setLoading(false);
        }else if(!MobileNumber){
            toast.warning("Please enter Mobile Number");
            setLoading(false);
        }else if(!Gender){
            toast.warning("Please select Gender");
            setLoading(false);  
        }else if(!DepartmentId){
          toast.warning("Please select Department");
          setLoading(false);              
        }else if(!RoleId){
            toast.warning("Please select Role");
            setLoading(false);   
        }else if(PassCodeCheck && !AppAccessEnabled){
          toast.warning("Please revoke your App Access First");
          setLoading(false);           
        }else{
            const endPointVariableKey = {
                buildingId:myUserData?.buildingId
            }
            let response = await commonAPI("ServiceStaffUpdate", bodydata, endPointVariableKey);
            if(response?.success == true && response?.message?.length == 0){
                toast.success("Service Staff Updated"); 
                // console.log(response.success);
                fetchData();
                setShow(false)
                setLoading(false);
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
            }
        }    

    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = JSON.stringify({ 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodydata,
            "uri": "ServiceStaffUpdate",
            "errorNumber": "USS01",
            "errorSource": ErrorSource,
            "errorSummary": error?.message,
            "errorDescription": error?.message,
            "fileClassName": "ServiceStaff.js",
            "functionName": "ServiceStaffUpdate",
        });
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }
  }

  
  const openUpdateModal = (item) => {
    console.log("item image",item)
        setFileURL(item?.userImageURL)
        setBase64("")
        setFileExt("")
        setStaffId(item?.staffId)
        setShow9(true)
    };

  async function UpdateProfile() {

    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodydata = {
        "modifiedUserId": JSON.stringify(myUserData?.userId),
        "staffId": parseInt(StaffId),
        "userImagebase64String": base64 ? base64 : null,
        "fileExtn": FileExt ? FileExt : null
    }
    console.log("bodydataServiceStaffUpdate", bodydata)
    try {
        setLoading(true);
        
        if(!base64){
            toast.warning("Please upload Staff Image");
            setLoading(false);   
        }else{
            const endPointVariableKey = {
                buildingId:myUserData?.buildingId
            }
            let response = await commonAPI("ServiceStaffImage", bodydata, endPointVariableKey);
            if(response?.success == true && response?.message?.length == 0){
                toast.success("Service Staff Updated Image"); 
                // console.log(response.success);
                fetchData();
                setShow9(false)
                setLoading(false);
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
            }
        }    

    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = JSON.stringify({ 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodydata,
            "uri": "ServiceStaffImage",
            "errorNumber": "AT01",
            "errorSource": ErrorSource,
            "errorSummary": error?.message,
            "errorDescription": error?.message,
            "fileClassName": "ServiceStaff.js",
            "functionName": "UpdateProfile",
        });
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }
  }

  const capitalizeWords = (text) => {
    if (!text) return ''; // Handle null or undefined
    return text
        .toLowerCase() // Convert to lowercase first
        .split(' ') // Split into words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
        .join(' '); // Join back into a string
  };

   const MobileOtpApi = async () => {
          const bodydata = { 
              "templateKey": "OTP",
              "smsTo": MobileNumber,
              "appSource": "CuroNext",
              "placeHolderList": {
                  "{#appname#}": "CuroNext",
                  "{#otp#}": ""
              }
          };
          try {
              if(!MobileNumber){
                  toast.warning("Please enter mobile number");
              } else if (MobileNumber.length !== 10) {
                toast.warning("Please enter a valid 10-digit mobile number");
              }else{
                  let response = await commonAPI("MobileOTP", bodydata)
                  console.log("otp response", response.data);
                  if(response.success == true & response.message.length == 0){
                      // alert("OTP sent to your mobile number");  
                      toast.success("OTP sent to your mobile number");
                      setOTPMatch(response.data)
                      setOTPgentime(Date.now())
                      setOTPShow(false)
                  }else{
                      toast.error(response.message[0]);
                      setShowHide(false)
                  }
              }
              
          } catch (error) {
              setLoading(false);
              const bodyError = { 
                  "errorLogId": 0, // Need to be change
                  "userId": 2, // Need to be change
                  "mobileNumber": "", 
                  "requestJSON": bodydata,
                  "uri": "/api/Notification/MobileOTP",
                  "errorNumber": "POTP01",
                  "errorSource": ErrorSource,
                  "errorSummary": error.message,
                  "errorDescription": error.message,
                  "fileClassName": "Registration.js",
                  "functionName": "OtpApi",
              };
              let response = await commonAPI("ErrorLogMaster", bodyError)
             
              if(response.success === true && response.message.length == 0){
                  toast.error("Something went wrong");
                  setLoading(false); 
              }else{
                  toast.error("Something went wrong");
                  setLoading(false); 
              }
          }
          
            
            
   }

   const matchOTP = async () => {
           try {
               console.log("OTP", OTPMatch, OTP);
               if(!OTP){
                    toast.warning("Please enter OTP");
                    return;
               }
               // Calculate the time difference in minutes
               const currentTime = Date.now();
               const timeDifference = (currentTime - OTPgentime) / (1000 * 60); // Convert to minutes
               console.log("timeDifference", timeDifference, OTPgentime, currentTime);
               if (OTPMatch == OTP) {
                   if (timeDifference <= 10) { // Check if the OTP is within 10 minutes
                       setShowHide(true);
                       console.log("OTP verified successfully");              
                       return;
                   } else {
                       toast.error("OTP has expired. Please request a new one.");
                       setShowHide(false);
                   }
               } else {
                   toast.error("Please enter a valid OTP");
                   setShowHide(false);
               }
           } catch (error) {
               console.error("Error in OTP verification:", error);
           }
       };


  return (<>
    {loading ?
      <div className="loaderDiv">
        <div className="loader"></div>
      </div>
      : null}
    <div className="row mb-3 mt-5 pt-2" style={{ alignItem: 'center' }}>
      <div className="col-lg-5 col-md-5">
        <div className="HeadingTop">
          <h3> Service Staff </h3>
          <span> Keep track of service personnel working in the society.</span>
        </div>
      </div>


      <div className="col-lg-7 col-md-7 mb-3 mb-md-0  text-right" style={{alignContent:'center'}}>
        <input type="text" placeholder="Search by staff name" className="sltareamodal col-3 ml-auto" style={{padding: "7px 40px 5px 10px", marginRight: 10}} value={SearchUser} onChange={(e) => filterServiceStaffData(e.target.value)}  />
        <select size="md"  name="taskTypes"    className="sltareamodal col-2 ml-auto" value={JobTypeSelectId}  onChange={(e) => {setJobTypeSelectId(e.target.value)  }}>
            <option value="">Job Type</option>
            <option value="PERMANENT" >Permanent</option>
            <option value="TEMPORARY" >Temporary</option>
            <option value="PROBATION" >Probation</option>
        </select> 
        <select size="md"  name="taskTypes"    className="sltareamodal col-2 ml-auto"  value={DepartmentIdSelected} onChange={(e) => {setDepartmentIdSelected(e.target.value); setRoleIdSelect("")}}>
            <option value="" >Department</option>
            {DepartmentList ? DepartmentList?.map((item, index) =>  <option key={index} value={item?.departmentId}>{item?.departmentName}</option>): null}
        </select> 
        <select size="md"  name="taskTypes"    className="sltareamodal col-2 ml-auto"  value={RoleIdSelect} onChange={(e) =>
                setRoleIdSelect(e.target.value)}>
            <option value="">Role</option>
            {RoleListSelect ? RoleListSelect?.map((item, index) =>  <option key={index} value={item?.roleId}>{item?.roleName}</option>): null}
        </select> 
        <Button variant="btn btn-info" onClick={() => openCreateModal()}>+ Create New </Button>{' '}
      </div>





      
    </div>

    <div className="row">
      {logo?.map((logoImg, index) => {
        return <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
          <div className="clientTiles" style={{height:168}}>
              <div className="ClientImg">
                  <div className="tabs_img">
                    {logoImg.userImageURL ?
                        <div className="relativeimgspan" onClick={() => {openUpdateModal(logoImg)}}>
                             {/* <FontAwesomeIcon icon={faPen}  onClick={() => {openUpdateModal(logoImg)}}/> */}
                             <img src={logoImg.userImageURL} alt={index} class="img img-responsive"/>
                            {/* <span onClick={() => {openUpdateModal(logoImg)}}> View </span> */}
                        </div>
                        :
                        <div className="relativeimgspan" onClick={() => {openUpdateModal(logoImg)}}>
                             {/* <FontAwesomeIcon icon={faPen} onClick={() => {openUpdateModal(logoImg)}}  /> */}
                             <img src={ServiceIcon} class="img img-responsive" />
                            {/* <span> View </span> */}
                        </div>
                        
                        
                    }   
                  </div>
                  <div className="l-two ml-2">
                    <h1 style={{marginTop: -5, width: 162}}> <span style={{ fontSize: 18}}>{logoImg?.userName} </span></h1>
                    <h4 style={{marginTop: -10}}>{logoImg?.mobileNumber} </h4>
                    <h4 style={{marginTop: -7}}>{capitalizeWords(logoImg?.gender)} </h4>
                  </div>
  

                  <div class="bars_font">
                    {logoImg?.passCode ?
                      <>  
                        {ShowPassword === logoImg.staffId ?
                          <h3 className="nakedeye" onClick={() => {setShowPassword(null)}}>
                            <FontAwesomeIcon icon={faEyeSlash}  />
                            <h6 style={{position: "absolute", fontSize: 21, top: 64}}>{logoImg?.passCode}</h6>
                          </h3>:
                          <h3 className="nakedeye" onClick={() => {setShowPassword(logoImg?.staffId)}}>
                            <FontAwesomeIcon icon={faEye}  />
                            <h6 style={{position: "absolute", fontSize: 21, top: 64}}>******</h6>
                          </h3>
                        }
                      </>  
                    :null}  
                  </div>
                  <div class="elleisemode">
                      <h3 className="font_trigger" >
                          <FontAwesomeIcon icon={faEllipsisVertical}  />
                      </h3>
                      <div class="ellipsemodetext" style={{top: 30,minWidth: '110px'}}>
                          <ul>
                            <li style={{fontSize:'12px',paddingTop:'7px',cursor:'pointer'}} onClick={() => { updateCompanyLogo(logoImg) }} > <FontAwesomeIcon icon={faPenToSquare}  /> Edit  </li>
                            <li style={{fontSize:'12px',paddingTop:'7px',cursor:'pointer'}} onClick={() => {DeleteStaff(logoImg)}}> <FontAwesomeIcon icon={faTrash}  /> Delete </li>
                            {logoImg?.userId && logoImg?.userMappingId && logoImg?.isMobileAuthenticated ? <>
                             {logoImg?.passCode  ?
                              <li style={{fontSize:'12px',paddingTop:'7px',cursor:'pointer'}} onClick={() => {revokeAppAccess(logoImg)}}> <FontAwesomeIcon icon={faUserAltSlash}  /> Revoke App Access </li>
                             :
                             <li style={{fontSize:'12px',paddingTop:'7px',cursor:'pointer'}} onClick={() => {AppAccess(logoImg)}}> <FontAwesomeIcon icon={faKey}  /> App Access </li>
                            }
                            </>:null}
                           

                          </ul>
                      </div>
                  </div> 
              </div>
              <div className="ClientText">
                  <div className="l-two">
                      
                       
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                        {logoImg?.fatherName ?
                          <>
                            <div class="flex-tower">
                              <span> Father Name </span>
                              <p style={{width: 190, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{logoImg?.fatherName}</p>
                            </div>
                          </>  
                              :null} 
                          {logoImg?.jobType ?    
                            <div class="flex-tower">
                              <span> Job Type </span>
                              <p>{capitalizeWords(logoImg.jobType)} </p>
                            </div>
                          :null}
                        </div>  
                       
                       <div class="flex-tower">
                          <span> Department (Role) </span>
                          <p style={{width: 264, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{logoImg?.departmentName}:- {logoImg?.roleName} </p>
                        </div>
                  </div>
              </div>
          </div>
      </div>
        
      })}

      {!logo?.length &&  logo?.length != null ? 
      <div className='bg-white' style={{height: "400px", borderRadius: "10px"}}>
          <div className='col-12 text-center'>
              <img src={NoCompany} alt="user" class="mx-auto mt-5" style={{height: "150px"}} />
          </div>    
          <br />
          <h3 className='col-12 text-center' style={{marginTop: "0px"}}> No Service Staff Found</h3>
          <h5 className='col-12 text-center' style={{marginTop: "10px"}}> Click on Create New button to add a Service Staff</h5>
      </div> :null}


    </div>
    <Modal size="md" show={show} onHide={() => setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
      <Modal.Header closeButton className='headerMDL'>
        <Modal.Title id="contained-modal-title-vcenter" onClick={openCreateModal}>
          {ModalText ?  "Add Service Staff" : "Update Service Staff" }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="helpingElelemnt_uuy002">


      <div className="container">
                      
                      <div className="row" id="validation">
                    <div className="col-12">
                       
                            
                         
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    
                                        <div className="content clearfix">
                                     
                                    
                                    <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current" aria-hidden="false">
                                        <div className="row text-left">

                          <div className="col-md-12 mb-2 px-0">
                            {!ShowHide ?
                              <>
                                <div className="form-group mt-2">
                                  <label for="wlastName2"> Mobile Number  <span className="danger">*</span> </label>
                                  <input type="number" value={MobileNumber} onChange={(e) => { setMobileNumber(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> 
                                </div>

                                <div className="form-group mt-2">
                                  <label for="wlastName2"> OTP  <span className="danger">*</span> </label>
                                  <input type="number" value={OTP} onChange={(e) => { setOTP(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> 
                                </div>
                              </>
                              :
                              <>

                                {ModalText ?
                                    <>
                                        {imgSizeLarge && <div className="imgSizeLine text-center small">Image Size is Exceeded </div>}
                                        <div className="form-group parentUploadContainer">

                                        

                                        

                                            <label for="wfirstName2" className='uploadcontainer' style={{width:"238px"}}> <FontAwesomeIcon icon={faPaperclip} />  &nbsp; Service Staff Image

                    
                                            <input type="file" onChange={(e) => { handleFileChange(e) }} value={''} className="form-control required" id="wfirstName2" name="firstName" aria-required="true" />
                                            {fileURL && <img src={fileURL} alt="Selected" className="img-fluid" style={{ width: "100px" }} />}
                                            
                                            </label> 
                            
                                        </div>
                                    
                                        <label className="text-danger mb-0"><span className="danger">*</span> Allowed File Types- JPEG/JPG/PNG.</label>
                                        <br/>
                                            <label className="text-danger mb-2"><span className="danger">*</span>Maximum image size - 50KB</label>
                                        <br/>
                                    </>    
                                :null}

                                <div className="form-group">
                                  <label for="wlastName2"> Staff Name  <span className="danger">*</span> </label>
                                  <input type="text" value={StaffName} onChange={(e) => { setStaffName(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>
                                <div className="form-group mt-2">
                                  <label for="wlastName2"> Email  </label>
                                  <input type="email" value={EmailId} onChange={(e) => { setEmailId(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>
                                {MobileShowHide ?
                                  <div className="form-group mt-2">
                                    <label for="wlastName2"> Mobile Number  <span className="danger">*</span> </label>
                                    <input type="number" value={MobileNumber} onChange={(e) => { setMobileNumber(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> 
                                  </div>
                                  :null}
                                <div style={{display: "flex", justifyContent: "space-between"}}>  
                                    <div className="col-6 pl-0">
                                        <div className="form-group fixChevron mt-2 col-12 p-0">
                                        <label >Gender <span className="danger">*</span></label>
                                        <select  name="taskTypes" className="form-control" style={{height: 30}} value={Gender} onChange={(e) =>
                                            setGender(e.target.value)}>
                                            <option value="" >Select Gender</option>
                                            <option value="MALE" >Male</option>
                                            <option value="FEMALE" >Female</option>
                                            <option value="OTHER" >Other</option>
                                        </select>
                                        <FaChevronDown className="absChevron" size={"10px"}/>   

                                        </div>
                                    </div>    
                                    <div className="col-6 pr-0 pl-0">
                                        <div className="form-group fixChevron mt-2 col-12 p-0">
                                          <label for="wlastName2"> Date of Birth    </label>
                                          <input type="date" value={Dob} max={new Date().toISOString().split("T")[0]} onChange={(e) => { setDob(e.target.value) }} className="form-control required" />
                                            

                                        </div>
                                    </div>    
                                  
                                </div> 

                                <div className="form-group mt-2">
                                  <label for="wlastName2"> Father Name  </label>
                                  <input type="text" value={FatherName} onChange={(e) => { setFatherName(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>  

                                <div className="form-group mt-2">
                                  <label for="wlastName2"> Current Address  </label>
                                  <input type="textarea" value={Address} onChange={(e) => { setAddress(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>  
      

                                <div style={{display: "flex", justifyContent: "space-between"}}>  
                                    <div className="col-6 pl-0">
                                        <div className="form-group fixChevron mt-2 col-12 p-0">
                                            <label for="wlastName2"> Date of Join   </label>
                                            <input type="date" value={Doj} onChange={(e) => { setDoj(e.target.value) }} className="form-control required" /> 
                                        </div>  
                                    </div>    
                                    <div className="col-6 pr-0 pl-0">
                                        <div className="form-group fixChevron mt-2 col-12 p-0">
                                        <label >Job Type </label>
                                            <select  name="taskTypes" className="form-control w-100" style={{height: 30}} value={JobType} onChange={(e) =>
                                                setJobType(e.target.value)}>
                                                <option value="">Select Job</option>
                                                <option value="PERMANENT" >Permanent</option>
                                                <option value="TEMPORARY" >Temporary</option>
                                                <option value="PROBATION" >Probation</option>
                                            </select>
                                            <FaChevronDown className="absChevron" size={"10px"}/>   
                                        </div>

                                    </div>    
                                  
                                </div> 

                                <div style={{display: "flex", justifyContent: "space-between"}} className="mb-5 pb-5">  
                                    <div className="col-6 pl-0">
                                        <div className="form-group fixChevron mt-2 col-12 p-0">
                                        <label >Department <span className="danger">*</span></label>
                                        <select style={{height: 30}} name="taskTypes" className="form-control" value={DepartmentId} onChange={(e) =>
                                          {setDepartmentId(e.target.value); setRoleId(""); const selectedDepartment = DepartmentList.find(dept => dept.departmentId === Number(e.target.value)); console.log("selectedDepartment",selectedDepartment, e.target.value); setAppAccessEnabled(selectedDepartment?.appAccessEnabled || false);}}>
                                          <option value="" >Select Department</option>
                                          {DepartmentList ? DepartmentList?.map((item, index) =>  <option key={index} value={item?.departmentId}>{item?.departmentName}</option>): null}
                                        </select>
                                        <FaChevronDown className="absChevron" size={"10px"}/>   

                                        </div>
                                    </div>    
                                    <div className="col-6 pr-0 pl-0">
                                        <div className="form-group fixChevron mt-2 col-12 p-0">
                                            <label >Role <span className="danger">*</span></label>
                                            <select style={{height: 30}}  name="taskTypes" className="form-control w-100" value={RoleId} onChange={(e) =>
                                                setRoleId(e.target.value)}>
                                                <option value="">Select Role</option>
                                                {RoleList ? RoleList?.map((item, index) =>  <option key={index} value={item?.roleId}>{item?.roleName}</option>): null}
                                            </select>
                                            <FaChevronDown className="absChevron" size={"10px"}/>   

                                        </div>
                                    </div>    
                                  
                                </div> 

                              </>
                            }   
                        

                            


                          </div>


                        </div>
                      </section>

                      </div>
 
                    </form>
                  
                </div>
              </div>
            
          </div> 
      </Modal.Body>



      <div class="cutomStriper"><div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="d-flex flex-row-reverse">
      {!ModalText ? 
      <>
      <button type="button" className="btn btn-info" onClick={() => { performUpdate() }}> Update</button>
      <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
      </>
      : 
      <>
      {!ShowHide ?
        OTPShow ?
        <button type="button" className="btn btn-info" onClick={() => { MobileOtpApi() }}> Send OTP</button>
        :
        <button type="button" className="btn btn-info" onClick={() => { matchOTP() }}> Submit OTP</button>
      : 
        <button type="button" className="btn btn-info" onClick={() => { addServiceStaff() }}> Submit</button>
      }
      <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button> 
      </>}
      </div>
      </div>
      </div>



    </Modal>

    <Modal size="md" show={show2} onHide={() => setShow2(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
      <Modal.Header closeButton className='headerMDL'>
        <Modal.Title id="contained-modal-title-vcenter" onClick={openCreateModal}>
          {"Update Service Staff Image" }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="helpingElelemnt_uuy002">


      <div className="container">
                      
                      <div className="row" id="validation">
                    <div className="col-12">
                       
                            
                         
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    
                                        <div className="content clearfix">
                                     
                                    
                                    <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                                        <div className="row text-left">

                          <div className="col-md-12 mb-2 px-0">
                            
                                    {imgSizeLarge && <div className="imgSizeLine text-center small">Image Size is Exceeded </div>}
                                    <div className="form-group parentUploadContainer">

                                    

                                    

                                        <label for="wfirstName2" className='uploadcontainer' style={{width:"238px"}}> <FontAwesomeIcon icon={faPaperclip} />  &nbsp; Service Staff Image

                
                                        <input type="file" onChange={(e) => { handleFileChange(e) }} value={''} className="form-control required" id="wfirstName2" name="firstName" aria-required="true" />
                                        {fileURL && <img src={fileURL} alt="Selected" className="img-fluid" style={{ width: "100px" }} />}
                                        
                                        </label> 
                        
                                    </div>
                                
                                    <label className="text-danger mb-0"><span className="danger">*</span> Allowed File Types- JPEG/JPG/PNG.</label>
                                    <br/>
                                        <label className="text-danger mb-0"><span className="danger">*</span>Maximum image size - 50KB</label>
                                    <br/>
                               

                            


                          </div>


                        </div>
</section>

                      </div>
 
                    </form>
                  
                </div>
              </div>
            
          </div> 
      </Modal.Body>
      <div className="fixed_allbtn">                        
              <div className="upload_btn"> 

                          <div className="  align-self-start">
                           

<div className="  align-self-start">
  <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
  <button type="button" className="btn btn-info" onClick={() => { UpdateProfile() }}> Update</button>
</div>
  
                          </div>

 
                                          </div>
 </div>

    </Modal>

    <Modal
        show={show9}
        onHide={() => setShow9(false)}
        size="md"
        className="m-0 p-0 pt-5"
      >
        <Modal.Header className="headerMDL" closeButton>
          <Modal.Title
            id="example-modal-sizes-title-lg"
            onClick={() => setShow9(false)}
          >
            Image
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-2">
          <div className="border-hike">
            <div className="row">
              <div className={`col-lg-12 col-md-12 col-sm-12 col-12 text-center ${base64 ? 'mb-5' : 'mb-1'}`}>
               
                  {imgSizeLarge && <div className="imgSizeLine text-center small">Image Size is Exceeded </div>}
                    <div className="form-group parentUploadContainer" style={{marginBottom: 80}}>

                        
                        <input id="file-upload" type="file" onChange={(e) => { handleFileChange(e) }} value={''} className="form-control required"  name="firstName" aria-required="true" />
                        {fileURL ? <img src={fileURL} alt="Selected" className="img-fluid" style={{ width: "350px" }} />
                          :   
                          <img src={ServiceIcon} alt="Selected" className="img-fluid" style={{ width: "350px" }} />
                      }
                       
        
                    </div>
                    <label htmlFor="file-upload" className="custom-file-upload mt-2" >
                      Browse Image
                    </label>
                    <label className="text-danger mb-0 float-left" style={{fontSize: 12}}><span className="danger">*</span> Allowed File Types- JPEG/JPG/PNG.</label>
                    <br />
                    <br />
                    <label className="text-danger mb-2 float-left" style={{fontSize: 12}}><span className="danger">*</span>Maximum image size - 50KB</label>
                  
                {/* </label> */}
                {/* <input
                  id="filePicker"
                  style={{ display: "none" }}
                  type={"file"}
                /> */}
              </div>
            </div>
          </div>
        </Modal.Body>
        {base64 ?
          <div class="fixed_allbtn mt-5">
            <div class="upload_btn">
              <ul role="menu" aria-label="Pagination" class="mb-0">
                <div class="  align-self-start">
                  <button
                    type="button"
                    class="btn border bg-white mr-2"
                    onClick={() => setShow9(false)}
                  >
                    {" "}
                    Cancel
                  </button>
                  <button type="button" className="btn btn-info" onClick={() => { UpdateProfile() }}> Update</button>
                </div>
              </ul>
            </div>
          </div>
        :null}  
      </Modal>

    <Modal centered show={DeleteShow} onHide={() =>
      setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
      <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
        <div className="row px-3" id="validation">
          <div className="col-12 bg-white pt-3 pb-2">
            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
              <div className="FnFtxt">
                <h2> Delete Service Staff  </h2>
                <h3> Are you sure you want to delete? </h3>
              </div>
            </div>

          </div>

        </div>
        <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
          <div className='both_ConfrmBTN col-6' onClick={() => DeleteServiceStaff()}>
            <Button variant="danger">Delete</Button>{' '}
          </div>
          <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
            <Button variant="light"> Cancel</Button>{' '}
          </div>
        </div>
      </Modal.Body>
    </Modal>

    <Modal centered show={AccessShow} onHide={() =>
      setAccessShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
      <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
        <div className="row px-3" id="validation">
          <div className="col-12 bg-white pt-3 pb-2">
            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
              <div className="FnFtxt">
                <h2> Grante App Access  </h2>
                <h3> Are you sure you want to grant access? </h3>
              </div>
            </div>

          </div>

        </div>
        <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
          <div className='both_ConfrmBTN col-6' onClick={() => addAppAccess()}>
            <Button variant="btn btn-primary">Continue</Button>{' '}
          </div>
          <div className='both_ConfrmBTN col-6' onClick={() => setAccessShow(false)} >
            <Button variant="light"> Cancel</Button>{' '}
          </div>
        </div>
      </Modal.Body>
    </Modal>

    <Modal centered show={RevokeAccessShow} onHide={() =>
      setRevokeAccessShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
      <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
        <div className="row px-3" id="validation">
          <div className="col-12 bg-white pt-3 pb-2">
            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
              <div className="FnFtxt">
                <h2> Revoke App Access  </h2>
                <h3> Are you sure you want to revoke access? </h3>
              </div>
            </div>

          </div>

        </div>
        <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
          <div className='both_ConfrmBTN col-6' onClick={() => removeAppAccess()}>
            <Button variant="danger">Continue</Button>{' '}
          </div>
          <div className='both_ConfrmBTN col-6' onClick={() => setRevokeAccessShow(false)} >
            <Button variant="light"> Cancel</Button>{' '}
          </div>
        </div>
      </Modal.Body>
    </Modal>
    <ToastContainer />
  </>)
}
export default ServiceStaff